// extracted by mini-css-extract-plugin
module.exports = {"inputBox":"TextArea_inputBox__bqkoa","textarea":"TextArea_textarea__1J2_-"};